import React from 'react';
import panelActions from '../panel/action/panelActions';
import BuilderActions from '../builder/action/builderActions';
import { findIndex } from 'underscore';

class AddPanel extends React.Component {
    constructor(props) {
      super(props);
      this.allLayout = [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
      this.addNewLayout = this.addNewLayout.bind(this);
      this.displayName = 'AddPanel';
      this.state = { rangeValue: 12 };
      this.valueIncrement = this.valueIncrement.bind(this);
      this.valueDecrement = this.valueDecrement.bind(this);
    }
    valueIncrement() {
      let value = this.state.rangeValue;
      if ((value + 1) > 12) {
        return;
      }
      value += 1;
      this.setState({ rangeValue: value });
      if (this.layoutType !== undefined) {
        this.setState({ errorMsg: null });
      }
    }

    valueDecrement() {
      let value = this.state.rangeValue;
      if ((value - 1) < 1) {
        return;
      }
      value -= 1;
      this.setState({ rangeValue: value });
      if (this.layoutType !== undefined) {
        this.setState({ errorMsg: null });
      }
    }

    handleLayoutChange(type, layout, val) {
      switch (type) {
        case 'type':
          this.layoutType = val.value;
          if (this.state.rangeValue !== 0) {
            this.setState({ errorMsg: null });
          }
          break;
        case 'layout':
          this.layout = layout;
          break;
        default: break;
      }
    }
    addNewLayout(e) {
      e.preventDefault();
      const Index = _.indexOf(this.allLayout, this.state.rangeValue);
      if (this.layoutType !== undefined && Index !== -1) {
        const allLayout = this.props.allLayout !== '' ? this.props.allLayout : [];
        const newLayout = {
          type: this.layoutType,
          layout: this.state.rangeValue,
          uid: new Date().getTime(),
          position: allLayout.length + 1,
        };

        allLayout.push(newLayout);
        const pushLayout = {
          allLayout,
          'shortcodeKey': this.props.shortcodeKey,
        };
        BuilderActions.saveAllBlocks(pushLayout);
        this.props.onClickedPanel();
      } else {
        this.setState({ errorMsg: 'Grid layout Or Grid Type not selected.' });
      }
    }

    render() {
      // for showing different layout
      const index = findIndex(this.props.allLayout, { type: 'grid' });
      const isMap = findIndex(this.props.allLayout, { type: 'map' });
      const isIsotop = findIndex(this.props.allLayout, { type: 'isotope' });
      let options = [];

      if (index === -1) {
        const simpleItem = { value: 'grid', label: API.LANG.GRID, icon: 'ion-grid' };
        options.push(simpleItem);
      }
      if (isMap === -1) {
        const simpleItem = { value: 'map', label: API.LANG.MAP, icon: 'ion-map' };
        options.push(simpleItem);
      }
      if (isIsotop === -1) {
        const simpleItem = { value: 'isotope', label: API.LANG.GRID_ISOTOPE, icon: 'ion-ios-keypad' };
        options.push(simpleItem);
      }
      options = options.concat([
          { value: 'search', label: API.LANG.SEARCH, icon: 'ion-android-locate' },
          { value: 'category', label: API.LANG.CATEGORY, icon: 'ion-steam' },
          // { value: 'calendar', label: 'Calendar', icon: 'ion-android-calendar' },
      ]);

      // if (API.isActiveUserplace === 'true') {
      //   options.push({ value: 'user', label: API.LANG.USER });
      // }
      const showOption = (item, itemIndex) => {
        return (<li className="search-content" key={itemIndex}>
          <input type="radio" name="search-element" id={itemIndex} value={item.value} onChange={this.handleLayoutChange.bind(this, 'type', item.value, item)} />
          <label className="select-search-content" htmlFor={itemIndex}>
            <i className={item.icon}></i>
            {item.label}
          </label>
        </li>);
      };

      return (<div>
        <div className="grid-choose-option">
          <div className="flex-row">
            <div className="flex-sm-12 flex-xs-12">
              <span className="caption">{API.LANG.CHOOSE_GRID_LAYOUT}</span>
              <p><button onClick={ this.valueIncrement }><i className="fa fa-plus"></i></button></p>
              <p><button onClick={ this.valueDecrement }><i className="fa fa-minus"></i></button></p>
              <p className="gird-value-count">
                { this.state.rangeValue !== null ? this.state.rangeValue : null }
              </p>
            </div>
          </div>
        </div>
        <div className="">
          <div className=""></div>
          <div className="select-content">
          <div className="flex-row">
            <div className="flex-xs-12">
               <span className="caption">{API.LANG.SELECT_TYPE}</span>
            </div>
            <div className="flex-xs-12">
              <ul className="reactive-list-item">
                {options.map(showOption)}
              </ul>
            </div>
          </div>


          </div>
        </div>
        <div className="add-button-content">
         { this.state.errorMsg !== undefined ? <p className="error-body">{this.state.errorMsg}</p> : null }
          <a href="#" className="add-button" onClick={this.addNewLayout} > {API.LANG.ADD} </a>
        </div>
      </div>);
    }
}


AddPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'allLayout': React.PropTypes.array,
  'onClickedPanel': React.PropTypes.func,
};

export default AddPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/addPanel.js
 **/